import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Plus, Trash2 } from 'lucide-react';

import TextInput from '../../../components/ui/TextInput.jsx';
import CheckboxInput from '../../../components/ui/CheckboxInput';
import Button from '../../../components/ui/Button';

// Katılım soruları editörü (serbest metin). PipGoalsEditor deseninin aynısı:
// GenericFormDrawer'ın children'ında yaşar, kendi state'ini ebeveyn tutar.
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Label = styled.div`
  font-size: 13px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 10px;
`;

const Hint = styled.div`
  font-size: 12px;
  color: #6c757d;
  margin-top: 6px;
`;

const IconBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  color: #94a3b8;
  &:hover { background: #f1f5f9; color: #b02a37; }
`;

export default function RaffleQuestionsEditor({ questions, onChange, disabled }) {
  const { t } = useTranslation();

  const add = useCallback(
    () => onChange([...(questions || []), { text: '', isRequired: false }]),
    [questions, onChange],
  );

  const update = useCallback((idx, patch) => {
    const next = [...questions];
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  }, [questions, onChange]);

  const remove = useCallback(
    (idx) => onChange(questions.filter((_, i) => i !== idx)),
    [questions, onChange],
  );

  return (
    <Wrap>
      <Label>{t('raffle.questions.title')}</Label>
      {(questions || []).map((q, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Row key={q.id || `new-${idx}`}>
          <TextInput
            label={t('raffle.questions.text')}
            value={q.text}
            onChange={(e) => update(idx, { text: e.target.value })}
            disabled={disabled}
          />
          <CheckboxInput
            label={t('raffle.questions.required')}
            checked={!!q.isRequired}
            onChange={(v) => update(idx, { isRequired: v })}
          />
          <IconBtn type="button" onClick={() => remove(idx)} disabled={disabled} data-role="remove-question">
            <Trash2 size={15} />
          </IconBtn>
        </Row>
      ))}
      <div>
        <Button variant="outline" onClick={add} disabled={disabled} data-role="add-question">
          <Plus size={14} /> {t('raffle.questions.add')}
        </Button>
      </div>
      <Hint>{t('raffle.questions.hint')}</Hint>
    </Wrap>
  );
}
